import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import importerStyles from "@components/importer/ImporterPage.module.scss";
import { AccrualImporterUploadPrompt } from "./AccrualImporterUploadPrompt";
import { AccrualImporterReviewButton } from "./AccrualImporterReviewButton";
import { AccrualImporterDocumentRow } from "./accrualImporter.types";

interface Props {
    rowsReadyForImport: AccrualImporterDocumentRow[];
    hasImportsRunning: boolean;
    canClose: boolean;
    onHide: () => void;
    openUploadPrompt: () => void;
    confirmDocuments: (financialDocumentIds: number[]) => void;
    isConfirming: boolean;
}

export const AccrualImporterPageFooter: React.FC<Props> = ({
    rowsReadyForImport,
    hasImportsRunning,
    canClose,
    onHide,
    openUploadPrompt,
    confirmDocuments,
    isConfirming,
}) => {
    const closeButton =
        canClose && !hasImportsRunning ? (
            <WithHotkey
                hotKey="mod+enter"
                hotKeyDisplayPosition="inline"
                hotKeyOptions={{
                    description: "Close importer",
                    preventDefault: true,
                }}
            >
                {(hotkeyHint) => (
                    <Button
                        variant="primary"
                        size="md"
                        onClick={onHide}
                        rightIcon={hotkeyHint}
                    >
                        Close
                    </Button>
                )}
            </WithHotkey>
        ) : null;

    return (
        <CommandIsland sticky className={importerStyles.footer}>
            <AccrualImporterUploadPrompt uploadNew={openUploadPrompt} />
            <HStack gap={8}>
                <AccrualImporterReviewButton
                    rowsReadyForImport={rowsReadyForImport}
                    confirmDocuments={confirmDocuments}
                    isConfirming={isConfirming}
                    fallback={closeButton}
                />
            </HStack>
        </CommandIsland>
    );
};
